import script from "./TheResult.vue?vue&type=script&setup=true&lang=js"
export * from "./TheResult.vue?vue&type=script&setup=true&lang=js"

import "./TheResult.vue?vue&type=style&index=0&id=e9d2dbb4&scoped=true&lang=css"

import exportComponent from "/home/sergey/projects/tm/calc_furnace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9d2dbb4"]])

export default __exports__